import React, { useMemo, useState } from 'react';
import {
    Box,
    FormControl,
    FormGroup,
    ListItemText,
    MenuItem
} from '@mui/material';
import { ArrowLeftLinearIcon } from '../../../icons-lib';
import i18n from '../../../i18';
import CheckboxCustom from '../../../components/checkbox/CheckboxCustom';
import { getFilterField } from '../../../utils/formatName';
import { FixedSizeList } from 'react-window';
import Search from '../../../components/search';
const ROW_HEIGHT = 38;
export const FilterDetail = ({
    filterOptions,
    filters,
    selectedFilter,
    field,
    onValueChange,
    onBack
}) => {
    const selectedValues =
        filters.find((f) => f.field === getFilterField(selectedFilter))
            ?.value || [];

    const [searchValue, setSearchValue] = useState('');
    const handleSearchChange = (value) => setSearchValue(value);
    const filteredOptions = useMemo(() => {
        const searchLowerCase = searchValue.toLowerCase();
        return filterOptions.filter((option) =>
            option.name.toLowerCase().includes(searchLowerCase)
        );
    }, [searchValue, filterOptions]);

    const renderRow = ({ index, style }) => {
        const option = filteredOptions[index];

        if (!option) return null;

        const optionName = option.needTranslate
            ? i18n.t(`enums.${option.name}`)
            : option.name;
        const optionKey = option[option.filterKey] || option.id;
        const isSelected = selectedValues.includes(optionKey);

        return (
            <MenuItem
                key={optionKey}
                value={optionKey}
                selected={isSelected}
                onClick={() => onValueChange(optionKey)}
                style={style}
                sx={{
                    '&.Mui-selected': {
                        backgroundColor: (theme) =>
                            theme.palette.action.mainSelected
                    }
                }}
            >
                <CheckboxCustom checked={isSelected} />
                <ListItemText primary={optionName} sx={{ ml: 1 }} primaryTypographyProps={{ textOverflow: 'ellipsis', overflow: 'hidden' }} />
            </MenuItem>
        );
    };

    const listHeight = useMemo(() => {
        const itemCount = filteredOptions.length;
        const maxHeight = 300;
        const computedHeight = itemCount * ROW_HEIGHT;

        return itemCount > Math.floor(maxHeight / ROW_HEIGHT)
            ? maxHeight
            : computedHeight;
    }, [filteredOptions]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <MenuItem onClick={onBack}>
                <ArrowLeftLinearIcon sx={{ mr: 2 }} />
                {i18n.t(`columns.${field.label}`)}
            </MenuItem>
            <Search
                searchValue={searchValue}
                handleSearchData={(value) => handleSearchChange(value)}
                sx={{ m: 2, width: 'calc(100% - 32px)' }}
            />
            <FormControl>
                <FormGroup>
                    <FixedSizeList
                        height={listHeight}
                        width="100%"
                        itemSize={ROW_HEIGHT}
                        itemCount={filteredOptions.length}
                    >
                        {renderRow}
                    </FixedSizeList>
                </FormGroup>
            </FormControl>
        </Box>
    );
};
